<template>
  <AppPageCard>
    <template #card-title> Employee Away Assignment </template>
    <div>
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        {{ $t("EMPLOYEE.EMP") }}
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ getTitle() }}
      </span>

      <IndividualEmployeeAwayEntitlementTable
        :is-busy="isBusy"
        :items="items"
        :pagination="pagination"
        @onClickEntitlement="showModal"
      ></IndividualEmployeeAwayEntitlementTable>

      <EmployeeIndividualAwayAssignmentModal
        :assigned-away="form"
        :is-busy="isBusy"
        @formSubmitted="fetch"
      ></EmployeeIndividualAwayAssignmentModal>
    </div>
  </AppPageCard>
</template>

<script>
import { mapGetters } from "vuex";
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import IndividualEmployeeAwayEntitlementTable from "@/modules/company/components/away/entitlement/IndividualEmployeeAwayEntitlementTable";
import EmployeeIndividualAwayAssignmentModal from "@/modules/company/components/away/assignment/employee/EmployeeIndividualAwayAssignmentModal";
export default {
  name: "EmployeeIndividualAwayAssignmentPage",
  components: {
    EmployeeIndividualAwayAssignmentModal,
    IndividualEmployeeAwayEntitlementTable,
    AppPageCard,
  },
  data() {
    return {
      isBusy: false,
      selectedAway: this.form ?? {},
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTitle() {
      return this.$route.query.name;
    },

    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchEmployeeAwayIndividualEntitlementList", {
          id: this.$route.query.id,
        })
        .finally(() => (this.isBusy = false));
    },

    /**
     *
     * @param data
     */
    showModal(data) {
      console.log("Data ", data);

      this.isBusy = true;
      this.$store
        .dispatch("fetchEmployeeAwayIndividualEntitlementForm", {
          id: data.id,
        })
        .finally(() => (this.isBusy = false));

      this.$bvModal.show("away-page-assignment-modal");
    },
  },
  computed: {
    ...mapGetters({
      items: "getEmployeeAwayIndividualEntitlementList",
      pagination: "getEmployeeAwayIndividualEntitlementListPagination",
      form: "getEmployeeAwayIndividualEntitlementForm",
    }),
  },
};
</script>

<style scoped></style>
